import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
export default function trackAppleMapsAvailabilityErrorThrown({ facility, spotId = null, errorFetching = false, }) {
    try {
        SegmentUtils.track({
            event: 'Apple Maps Availability Error Thrown',
            properties: {
                facility_id: facility?.id ?? spotId,
                city: facility?.city ?? null,
                error_fetching: errorFetching,
            },
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - trackAppleMapsAvailabilityErrorThrown',
        });
    }
}
